'use client';

import { PropsWithChildren } from 'react';
import LoadingMessage from './LoadingMessage';
import GlassOverlay from '../overlay/GlassOverlay';

type Props = {
  active: boolean;
  messages?: string[];
};

/**
 * Shows the configured loading messages over the form while the submission
 * is in flight. Renders the children untouched when no messages are
 * configured.
 */
const FormLoadingOverlay = ({
  active,
  messages,
  children,
}: PropsWithChildren<Props>) => {
  if (!messages?.length) return children;

  return (
    <GlassOverlay
      active={active}
      overlay={<LoadingMessage messages={messages} active={active} />}
    >
      {children}
    </GlassOverlay>
  );
};

export default FormLoadingOverlay;
